module.exports = __webpack_public_path__ + "img/login_card.3ae49fd5.png";